/*!
 * ftdomdelegate v3.1.0 - Browser IIFE build
 * Exposes: window.domDelegate.Delegate
 */
(function(global){
  "use strict";

  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) this.root(root);
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }

  Delegate.prototype.root = function(root) {
    var map = this.listenerMap, t;
    if (this.rootElement) {
      for (t in map[1]) this.rootElement.removeEventListener(t, this.handle, true);
      for (t in map[0]) this.rootElement.removeEventListener(t, this.handle, false);
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) delete this.rootElement;
      return this;
    }
    this.rootElement = root;
    for (t in map[1]) this.rootElement.addEventListener(t, this.handle, true);
    for (t in map[0]) this.rootElement.addEventListener(t, this.handle, false);
    return this;
  };

  Delegate.prototype.captureForType = function(t) {
    return ["blur","error","focus","load","resize","scroll"].indexOf(t)!==-1;
  };

  Delegate.prototype.on = function(t, s, h, c) {
    if (!t) throw new TypeError("Invalid event type: "+t);
    if (typeof s==="function") {c=h; h=s; s=null;}
    if (c===void 0) c=this.captureForType(t);
    if (typeof h!=="function") throw new TypeError("Handler must be a function");
    var root=this.rootElement, map=this.listenerMap[c?1:0];
    if (!map[t]) { if (root) root.addEventListener(t,this.handle,c); map[t]=[]; }
    var m, mp;
    if (!s) { mp=null; m=matchesRoot.bind(this); }
    else if (/^[a-z]+$/i.test(s)) { mp=s; m=matchesTag; }
    else if (/^#[a-z0-9\-_]+$/i.test(s)) { mp=s.slice(1); m=matchesId; }
    else { mp=s; m=matches; }
    map[t].push({selector:s,handler:h,matcher:m,matcherParam:mp});
    return this;
  };

  Delegate.prototype.off = function(t,s,h,c){
    if (typeof s==="function"){c=h;h=s;s=null;}
    if (c===void 0){this.off(t,s,h,true);this.off(t,s,h,false);return this;}
    var map=this.listenerMap[c?1:0], list, i, l;
    if (!t){for(var tt in map) this.off(tt,s,h); return this;}
    list=map[t]; if (!list||!list.length) return this;
    for(i=list.length-1;i>=0;i--){var lst=list[i];
      if((!s||s===lst.selector)&&(!h||h===lst.handler)){
        this._removedListeners.push(lst); list.splice(i,1);
      }}
    if(!list.length){delete map[t]; if(this.rootElement) this.rootElement.removeEventListener(t,this.handle,c);}
    return this;
  };

  Delegate.prototype.handle=function(e){
    var type=e.type, root=this.rootElement, phase=e.eventPhase||(e.target!==e.currentTarget?3:2);
    if(e.ftLabsDelegateIgnore===true)return;
    var tgt=e.target; if(tgt.nodeType===3) tgt=tgt.parentNode; if(tgt.correspondingUseElement) tgt=tgt.correspondingUseElement;
    var list=[], lm=this.listenerMap, i,l,listener;
    switch(phase){case 1:list=lm[1][type];break;case 2:if(lm[0]&&lm[0][type])list=list.concat(lm[0][type]);if(lm[1]&&lm[1][type])list=list.concat(lm[1][type]);break;case 3:list=lm[0][type];break;}
    var toFire=[]; l=list?list.length:0;
    while(tgt&&l){for(i=0;i<l;i++){listener=list[i];if(!listener)break;
      if(tgt.tagName&&["button","input","select","textarea"].indexOf(tgt.tagName.toLowerCase())>-1&&tgt.hasAttribute("disabled")) toFire=[];
      else if(listener.matcher.call(tgt,listener.matcherParam,tgt)) toFire.push([e,tgt,listener]);}
      if(tgt===root)break; l=list.length; tgt=tgt.parentElement||tgt.parentNode; if(tgt instanceof HTMLDocument)break;}
    var ret; for(i=0;i<toFire.length;i++){if(this._removedListeners.indexOf(toFire[i][2])>-1)continue;
      var returned=this.fire.apply(this,toFire[i]); if(returned===false){toFire[i][0].ftLabsDelegateIgnore=true;toFire[i][0].preventDefault();ret=false;break;}}
    return ret;
  };

  Delegate.prototype.fire=function(e,t,l){return l.handler.call(t,e,t);};
  var matches=(function(el){if(!el)return;var p=el.prototype;return p.matches||p.matchesSelector||p.webkitMatchesSelector||p.mozMatchesSelector||p.msMatchesSelector||p.oMatchesSelector;})(Element);
  function matchesTag(n,el){return n.toLowerCase()===el.tagName.toLowerCase();}
  function matchesRoot(sel,el){if(this.rootElement===window){return el===document||el===document.documentElement||el===window;} return this.rootElement===el;}
  function matchesId(id,el){return id===el.id;}
  Delegate.prototype.destroy=function(){this.off();this.root();};

  global.domDelegate={Delegate:Delegate};
})(this);